import React, { useEffect, useState } from "react";

import Plot from "react-plotly.js";
import { machineProfile, sensor } from "../../../api/index.js";

import { decodeBase64ToDoubleList } from "../../../utils/helper.jsx";
import { useAuth } from "../../../contexts/AuthContext.jsx";
const feature_name_list = [
  {
    feature_name: "Envelope FFT",
    features: ["acc_waveform", "acc_waveform"],
    addition: true,
    x_label: "Frequency (Hz)",
    y_label: "Amplitude (m/s^2)",
  },
  {
    feature_name: "Velocity Waveform",
    features: ["time_signal_velocity", "time_vector_velocity"],
    x_label: "Time (s)",
    y_label: "Velocity (mm/s)",
  },
  {
    feature_name: "Velocity FFT",
    features: ["fft_amplitude_vel", "fft_freq_vel"],
    x_label: "Frequency (Hz)",
    y_label: "FFT Amplitude (mm/s)",
  },
  {
    feature_name: "Acceleration FFT",
    features: ["fft_amplitude_acc", "fft_freq_acc"],
    x_label: "Frequency (Hz)",
    y_label: "FFT Amplitude (m/s^2)",
  },
  {
    feature_name: "Acceleration Waveform",
    features: ["acc_waveform", "acc_waveform"],
    addition: true,
    x_label: "Time (s)",
    y_label: "Acceleration (m/s^2)",
  },
];
function VibrationOtherTab({
  min_date,
  max_date,
  deployment,
  timestamp,
  feature_name,
  axis,
  lightMode = false,
}) {
  const { config } = useAuth();
  const [selectedInterval, setSelectedInterval] = useState("Custom");
  const [vibrationData, setVibrationData] = useState([]);
  const [xAxis, setXAxis] = useState([]);
  const [maxY, setMaxY] = useState("");
  const [dataX, setDataX] = useState([]);
  const [dataY, setDataY] = useState([]);
  const [xLabel, setXLabel] = useState("");
  const [yLabel, setYLabel] = useState("");
  const [listRecording, setListRecording] = useState([]);

  useEffect(() => {
    const getListAcceleration = async () => {
      const query = {
        sensor_id: deployment?.sensor_id,
        machine_element_id: deployment?.machine_element_id,
        deployment_id: deployment?.id,
        interval: selectedInterval,
        start: min_date,
        end: max_date,
      };
      const resultAcc = await sensor.getAccelerationList(query);
      if (resultAcc.ok) {
        const bodyAcc = await resultAcc.json();
        const changeData = bodyAcc.data.map((d) => {
          return {
            ...d,
            label: d.recording_timestamp,
            value: d.recording_timestamp,
            formattedDate: d.recording_timestamp,
          };
        });
        getEnvelopeFFT(changeData);
        setListRecording(changeData);
      }
    };

    const getEnvelopeFFT = async (changeData) => {
      const recording = changeData.find(
        (i) => i.recording_timestamp === timestamp.replace("T", " ")
      );
      if (!recording) return;
      const query = {
        axis: axis,
        recording_id: recording.recording_id,
      };
      const result = await sensor.chartEnvelopeFFT(query);
      if (result.ok) {
        const body = await result.json();
        let data = JSON.parse(body.data);
        let d_x = [];
        let d_y = [];
        const chartData = data.map((x, index) => {
          d_x.push(x["Frequency (Hz)"]);
          d_y.push(x["Amplitude (gE - RMS)"]);
          return {
            x: x["Frequency (Hz)"],
            y: x["Amplitude (gE - RMS)"],
          };
        });
        // set dataX
        setDataX(d_x);
        setDataY(d_y);
        // setXLabel("Frequency (Hz)");
        setYLabel("Amplitude (gE - RMS)");
        setVibrationData(chartData);
      }
    };
    const getData = async () => {
      //console.log("geting sensor data");
      //console.log({ deployment });
      const query = {
        utc: true,
        sensor_id: deployment?.sensor_id,
        machine_element_id: deployment?.machine_element_id,
        deployment_id: deployment?.id,
        interval: selectedInterval,
        axis,
        feature_name,
        timestamp,
      };
      const result = await sensor.customChart(query);
      // set label for x and y based on feature_name
      const feature = feature_name_list.find(
        (x) => x.feature_name === feature_name
      );
      if (feature) {
        setXLabel(feature.x_label);
        setYLabel(feature.y_label);
      }
      if (result.ok) {
        const body = await result.json();
        let data = body.data;
        if (data.length) {
          const axis = feature_name_list.find(
            (x) => x.feature_name === feature_name
          )?.features;
          if (!axis) return;
          const x_raw = data.find((x) => x.feature_name === axis[1]);
          const y_raw = data.find((x) => x.feature_name === axis[0]);
          const result_x = decodeBase64ToDoubleList(x_raw.feature_value);
          const result_y = decodeBase64ToDoubleList(y_raw.feature_value);
          setDataX(result_x);
          setDataY(result_y);
          const result = result_x.map((x, index) => {
            return {
              name: index,
              x: x,
              y: result_y[index],
            };
          });
          setVibrationData(result);
        }
      }
    };
    if (feature_name === "Envelope FFT") {
      getListAcceleration();
    } else {
      getData();
    }
  }, []);

  function VibrationChart({ vibrationData }) {
    // useEffect(() => {
    //   console.log("maxY", maxY);
    // }, [maxY]);
    return (
      <>
        <div style={{ overflowX: "auto" }}>
          <div
            style={{
              width: {
                xs: "550px",
                md: "auto",
                lg: "auto",
                sm: "550px",
              },
            }}
          >
            <Plot
              data={[
                {
                  x: dataX,
                  y: dataY,
                  type: "line",
                },
              ]}
              layout={{
                width: "800",
                font: {
                  color: "#fff",
                },
                xaxis: {
                  gridcolor: "#506784",
                  linecolor: "#506784",
                  title: {
                    text: xLabel,
                    font: {
                      size: 13,
                      color: lightMode ? "#3d3d3d" : "#efefef",
                    },
                  },
                },
                yaxis: {
                  gridcolor: "#506784",
                  linecolor: "#506784",
                  title: {
                    text: yLabel,
                    font: {
                      size: 13,
                      color: lightMode ? "#3D3D3DFF" : "#eaeaea",
                    },
                  },
                },
              }}
            />
          </div>
        </div>
      </>
    );
  }

  return (
    <div>
      <div style={{ width: "200px" }}></div>

      <VibrationChart vibrationData={vibrationData} />
    </div>
  );
}

export default VibrationOtherTab;
